<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="d-sm-flex align-items-center justify-content-between mb-4" style="margin-bottom: 9px;margin-right: 1px;">
                    <h1 class="h3 mb-0 text-gray-800">Email Templates <i [popover]="esr" class="fas fa-question-circle pointer"></i></h1>
                    <popover-content #esr
                                     title="Email Templates"
                                     placement="right"
                                     [animation]="true"
                                     [closeOnClickOutside]="true">
                        <p>View standard templates you can use with your ELI assessments or create your own custom templates to fit your needs. Click on each template to modify content. Please watch Tutorial 7 for more information. You can learn all about this feature in Tutorial 7.</p>
                    </popover-content>
                    <div class="actionButtons">
                        <!--<a id="cShowFilter" (click)="toggleFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
                            <i *ngIf="!enableFilter" class="fas fa-filter text-white-50"> <span class="button-text"> Search</span></i>
                            <i *ngIf="enableFilter" class="fas fa-filter text-white-50"> <span class="button-text"> Hide Search</span></i>
                        </a>-->
                        <a *ngIf="currentSelectedTab != 2 && currentSelectedTab != 2.1 && currentSelectedTab != 2.2" [routerLink]="['/app/new_coach_email_template']" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                            <i class="fas fa-plus text-white-50"> <span class="button-text"> Create</span></i>
                        </a>
                    </div>

                </div>

                <ng-container *ngIf="loading">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <!--<div class="card shadow" >-->
                <div class="topSpacing" *ngIf="!loading">

                    <div>
                        <ul class="tab-nav">
                            <li id="standard-tab" (click)="currentTab(2)" class="active"><a data-toggle="tab" href="#Tab2">Standard Templates</a></li>
                            <li id="360-tab" (click)="currentTab(1)"><a data-toggle="tab" href="#Tab1">Custom Templates</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="Tab1" class="tab-pane fade">
                            <!--*ngIf="data.length > 0"-->
                            <div>
                                <ul class="nav nav-tabs">
                                    <li id="360-tab-reg-temp" (click)="currentTab(1.1)" class="active"><a data-toggle="tab" href="#myTemplatesRegular">ELI - Self Assessment</a></li>
                                    <li id="360-tab-360-temp" (click)="currentTab(1.2)"><a data-toggle="tab" href="#myTemplates360">ELI 360</a></li>
                                </ul>
                            </div>

                            <div class="tab-content">
                                <div id="myTemplatesRegular" class="tab-pane fade in active">
                                    <div class="containerGrid" style="width: 100%; max-height: 400px; height:400px;">
                                        <ag-grid-angular #agGrid
                                                         style="width: 100%; height: 100%;"
                                                         class="ag-theme-balham"
                                                         [enableFilter]="true"
                                                         [floatingFilter]="true"
                                                         [gridOptions]="gridOptions"
                                                         [rowData]="myTemplatesRegularData"
                                                         [columnDefs]="dataHeaders"
                                                         [enableSorting]="true"
                                                         [enableColResize]="true"
                                                         (rowClicked)="onRowClicked($event)"
                                                         (gridReady)="onGridReady($event, 1.1)"
                                                         [pagination]="true"
                                                         [paginationPageSize]="25"
                                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                         [rowSelection]="rowSelection"
                                                         (rowSelected)="onRowSelected($event)"
                                                         (selectionChanged)="onSelectionChanged($event)"
                                                         [rowMultiSelectWithClick]="true"
                                                         [suppressRowClickSelection]="true">
                                        </ag-grid-angular>
                                    </div>

                                </div>

                                <div id="myTemplates360" class="tab-pane fade">
                                    <div class="containerGrid" style="width: 100%; max-height: 400px; height:400px;">
                                        <ag-grid-angular #agGrid
                                                         style="width: 100%; height: 100%;"
                                                         class="ag-theme-balham"
                                                         [enableFilter]="true"
                                                         [floatingFilter]="true"
                                                         [gridOptions]="gridOptions"
                                                         [rowData]="myTemplates360Data"
                                                         [columnDefs]="dataHeaders"
                                                         [enableSorting]="true"
                                                         [enableColResize]="true"
                                                         (rowClicked)="onRowClicked($event)"
                                                         (gridReady)="onGridReady($event, 1.2)"
                                                         [pagination]="true"
                                                         [paginationPageSize]="25"
                                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                         [rowSelection]="rowSelection"
                                                         (rowSelected)="onRowSelected($event)"
                                                         (selectionChanged)="onSelectionChanged($event)"
                                                         [rowMultiSelectWithClick]="true"
                                                         [suppressRowClickSelection]="true">
                                        </ag-grid-angular>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div id="Tab2" class="tab-pane fade in active">
                            <div>
                                <ul class="nav nav-tabs">
                                    <li (click)="currentTab(2.1)" class="active"><a data-toggle="tab" href="#standartRegular">ELI - Self Assessment</a></li>
                                    <li (click)="currentTab(2.2)"><a data-toggle="tab" href="#standart360">ELI 360</a></li>
                                </ul>
                            </div>

                            <div class="tab-content">
                                <div id="standartRegular" class="tab-pane fade in active">
                                    <div class="containerGrid" style="width: 100%; max-height: 400px; height:400px;">
                                        <ag-grid-angular #agGrid
                                                         style="width: 100%; height: 100%;"
                                                         class="ag-theme-balham"
                                                         [enableFilter]="true"
                                                         [floatingFilter]="true"
                                                         [gridOptions]="gridOptions"
                                                         [rowData]="standardRegularData"
                                                         [columnDefs]="standardDataHeaders"
                                                         [enableSorting]="true"
                                                         [enableColResize]="true"
                                                         (rowClicked)="onStandardRowClicked($event)"
                                                         (gridReady)="onGridReady($event, 2.1)"
                                                         [pagination]="true"
                                                         [paginationPageSize]="25"
                                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                         [rowSelection]="rowSelection"
                                                         (rowSelected)="onRowSelected($event)"
                                                         (selectionChanged)="onSelectionChanged($event)"
                                                         [rowMultiSelectWithClick]="true"
                                                         [suppressRowClickSelection]="true">
                                        </ag-grid-angular>
                                    </div>
                                </div>

                                <div id="standart360" class="tab-pane fade">
                                    <div class="containerGrid" style="width: 100%; max-height: 400px; height:400px;">
                                        <ag-grid-angular #agGrid
                                                         style="width: 100%; height: 100%;"
                                                         class="ag-theme-balham"
                                                         [enableFilter]="true"
                                                         [floatingFilter]="true"
                                                         [gridOptions]="gridOptions"
                                                         [rowData]="standard360Data"
                                                         [columnDefs]="standardDataHeaders"
                                                         [enableSorting]="true"
                                                         [enableColResize]="true"
                                                         (rowClicked)="onStandardRowClicked($event)"
                                                         (gridReady)="onGridReady($event, 2.2)"
                                                         [pagination]="true"
                                                         [paginationPageSize]="25"
                                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                         [rowSelection]="rowSelection"
                                                         (rowSelected)="onRowSelected($event)"
                                                         (selectionChanged)="onSelectionChanged($event)"
                                                         [rowMultiSelectWithClick]="true"
                                                         [suppressRowClickSelection]="true">
                                        </ag-grid-angular>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <!--</div>-->
            </div>
        </div>
    </div>
</div>


